export default __webpack_public_path__ + "static/media/mpn-picturemark-d.3549f0d4.svg";